import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Route, Switch, Redirect } from "react-router-dom";
import OnBoarding from "./OnBoarding";
import PersonalInfo from "./Personal";
import PersonalityInfo from "./Personality";
import HighSchoolInfo from "./HighSchool";
import AcademicInfo from "./Academic";
import AcademicInterestInfo from "./AcademicInterest";
import CollegeQuestions from './CollegeQues';
import CollegeExperience from './CollegeExp';
import ApplicationStatus from './ApplicationStatus'

const useStyles = makeStyles(theme => ({
  profile: {
    flexGrow: 1,
    padding:0,
  }
}));

const ProfileOnBoarding = ({ profile }) => {
  const classes = useStyles();
  return (
    <div className={classes.profile}>
      <Switch>
        <Route exact path="/onboarding" component={OnBoarding} />
        <Route path="/onboarding/1" component={PersonalInfo} />
        <Route path="/onboarding/2" component={HighSchoolInfo} />
        <Route path="/onboarding/3" component={AcademicInfo} />
        <Route path="/onboarding/4" component={AcademicInterestInfo} />
        <Route path="/onboarding/5" component={CollegeQuestions} />
        <Route path="/onboarding/6" component={CollegeExperience} />
        <Route path="/onboarding/7" render={(props) => <ApplicationStatus {...props} profile={profile} />} />
        {/* <Route path="/onboarding/7" render={(props) => <PersonalityInfo {...props} profile={profile} />} /> */}
      </Switch>
    </div>
  );
};

export default ProfileOnBoarding;
